/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FacebookShareData
 */
export interface FacebookShareData {
    /**
     * 
     * @type {string}
     * @memberof FacebookShareData
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof FacebookShareData
     */
    link: string;
    /**
     * 
     * @type {string}
     * @memberof FacebookShareData
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FacebookShareData
     */
    caption: string;
    /**
     * 
     * @type {string}
     * @memberof FacebookShareData
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof FacebookShareData
     */
    picture: string;
}

export function FacebookShareDataFromJSON(json: any): FacebookShareData {
    return FacebookShareDataFromJSONTyped(json, false);
}

export function FacebookShareDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacebookShareData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
        'link': json['link'],
        'name': json['name'],
        'caption': json['caption'],
        'description': json['description'],
        'picture': json['picture'],
    };
}

export function FacebookShareDataToJSON(value?: FacebookShareData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'link': value.link,
        'name': value.name,
        'caption': value.caption,
        'description': value.description,
        'picture': value.picture,
    };
}


